module.exports = __webpack_public_path__ + "img/betsize_btn.3c434a6b.png";